module.exports = __webpack_public_path__ + "media/images/selectionBet__decoPickWinner-301f48750dc17bae265903a1ef25eb15.png";